import React from 'react';

import Typography from 'components/typography/typography';

const ForeignDiplomasInstructions: React.FC = () => {
  return (
    <div className="w-full flex flex-col">
      <Typography as="p" variant="body-medium" className="text-gray600">
        Omdat je een buitenlands diploma hebt behaald, kun je deze niet
        downloaden bij DUO.
        <br />
        <br />
        Om toch te kunnen werken als freelancer in de kinderopvang neem je in
        dit geval contact op met het IDW (Internationale Diploma Waardering).{' '}
        <b className="text-current text-purple">
          Vraag hen om je diploma te laten erkennen.
        </b>
        <br />
        Je ontvangt van hen dan een waardering van je diploma.
        <br />
        <br />
        Upload vervolgens zowel je diplomawaardering als het originele
        buitenlandse diploma in pdf.
        <br />
      </Typography>
    </div>
  );
};

export default ForeignDiplomasInstructions;
